// extracted by mini-css-extract-plugin
export default {"availableTime":"style_availableTime__6J5iS"};